import { getProxiedServiceUrl } from 'gw-portals-url-js';
import { DocumentUploadService, DocumentDownloadService } from 'gw-portals-document-js';
import { JsonRPCService } from 'gw-portals-transport-js';

export default class GatewaySpreadsheetService {
    static uploadDocument(file, documentMetadata, additionalHeaders) {
        return DocumentUploadService.send(getProxiedServiceUrl('uploadSpreadsheet'), file, documentMetadata, additionalHeaders);
    }

    static downloadSpreadsheetTemplate(jobID, additionalHeaders, errorCallback) {
        const url = getProxiedServiceUrl('downloadSpreadsheet').concat(`/${jobID}`);
        return DocumentDownloadService.getDocument(url, additionalHeaders, errorCallback);
    }

    static retrieveBlankTemplate(jobNumber, additionalHeaders) {
        return JsonRPCService.send(getProxiedServiceUrl('uploadSpreadsheet'), 'retrieveBlankTemplate', [jobNumber], additionalHeaders);
    }
}
